import classNames from "classnames";
import Button from "Components/button";
import { hasEmptyRequiredFields, TextWidget } from "Components/optionForm";
import React, { useCallback } from "react";
import { requiredFields } from "../constants";
import locale from "./summaryReportEditor.locale";
export default function SummaryReportEditor(props) {
    var _a;
    const handleChangeDraft = useCallback((value, fieldName) => {
        fieldName &&
            props.onSetDraft &&
            props.onSetDraft({
                [fieldName]: value
            });
    }, [props.onSetDraft]);
    const isEmptyRequiredFields = hasEmptyRequiredFields(props.draft, requiredFields);
    const handleCancel = useCallback(() => {
        props.onSetDraft && props.onSetDraft({});
    }, [props.onSetDraft]);
    const handleSave = useCallback(() => {
        props.draft && props.onSaveSummaryReport && props.onSaveSummaryReport(props.draft);
    }, [props.onSaveSummaryReport, props.draft]);
    return (React.createElement("div", { className: classNames("flex-single-column with-gap-24", props.className) },
        React.createElement(TextWidget, { value: ((_a = props.draft) === null || _a === void 0 ? void 0 : _a.Name) || "", fieldName: "Name", onChange: handleChangeDraft, label: locale.NAME, labelMode: "floating", height: 45 }),
        React.createElement("div", { className: "d-flex justify-content-flex-end with-gap-8" },
            React.createElement(Button, { className: "btn-h-m p-8-24", text: locale.CANCEL, onClick: handleCancel, disabled: !props.hasChanges }),
            React.createElement(Button, { text: locale.SAVE, className: "btn-primary btn-h-m p-8-24", disabled: isEmptyRequiredFields || !props.hasChanges, onClick: handleSave }))));
}
